import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonList, IonPage, IonRadioGroup, IonRow, IonText, useIonToast } from '@ionic/react';
import {  createOutline, locationOutline, pricetagOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import LoadingContainer from '../../components/loading/LoadingContainer';
import Slideshow from '../../components/slideshow/Slideshow';
import HR from '../../layouts/HR';
import Toolbar2 from '../../layouts/Toolbar2';
import { baseUrl, isHome, isWebView, objIsEmpty } from '../../library/Funcs';
import { EventViewAction } from '../../redux/actions/Tour';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import './EventPage.css';
import Modal from 'react-responsive-modal';
import { AuthContext } from '../../context/AuthContext';

interface Props extends RouteComponentProps<{
  event_id: string
}> { }

const EventPage: React.FC<Props> = ({ match }) => {
  const history = useHistory();
  const [toast, dismiss] = useIonToast();

  const [toolbarBg, setToolbarBg] = useState('transparent')
  const [titleColor, setTitleColor] = useState('transparent')
  const [mapShow, setMapShow] = useState(false);

  const [applicances, setApplicances] = useState('');
  const [applicancesOptional, setApplicancesOptional] = useState('');

  const dispatch = useAppDispatch()
  const { loading, eventView } = useAppSelector(state => state.eventView)

  useEffect(() => {
    if (objIsEmpty(eventView)) {
      dispatch(EventViewAction(match.params.event_id));
    }

    return () => {
      if (isHome()) {
        dispatch({ type: 'EVENT_VIEW_RESET' })
      }
    }
  }, [dispatch])

  useEffect(() => {
    let applicancesText = '';
    let applicancesOptionalText = '';
    
    eventView.event?.appliances?.forEach((element: any) => {
      applicancesText += element + "، "
    })
    setApplicances(applicancesText.substring(0, applicancesText.length - 2));

    eventView.event?.appliances_optional?.forEach((element: any) => {
      applicancesOptionalText += element + "، "
    })
    setApplicancesOptional(applicancesOptionalText.substring(0, applicancesOptionalText.length - 2));
  }, [loading]);

  const showMapHandler = () => {
    setMapShow(true);
  }

  const hideMapHandler = () => {
    setMapShow(false);
  }

  const registerEventHandler = (auth: boolean) => {
    if (!auth) {
      toast({ message: "جهت ثبت نام سفر لطفا ابتدا وارد حساب کاربری خود شوید.", duration: 2000, color: "warning" });
      return;
    }

    if (eventView.user !== undefined && !eventView.user.allow) {
      toast({ message: eventView.user!.error, duration: 2000, color: "warning" });
      return;
    }

    if (eventView.user !== undefined && eventView.user.registered) {
      toast({ message: 'شما قبلا ثبت نام کرده اید.', duration: 2000, color: "warning" });
      return;
    }

    history.push(`/tour/register/${eventView.event?.id}`);
  }

  const changeHeightHandler = (e: any) => {
    const scrollY = e.detail.currentY;

    const alpha = scrollY / 180;

    setToolbarBg('rgba(8, 185, 138, ' + alpha + ')')

    if (scrollY > 210) {
      setTitleColor('rgba(255, 255, 255, 1)')
    } else {
      setTitleColor('transparent')
    }
  }

  const toolbarButtons = <React.Fragment>
    <IonButton shape="round" color="white" onClick={showMapHandler}>
      <IonIcon icon={locationOutline} />
    </IonButton>
  </React.Fragment>

  return <LoadingContainer loading={loading}>
    <IonPage className="tour">
      <Toolbar2 title={eventView.event?.title} endButtons={toolbarButtons} hasBackButton hasShadow background={toolbarBg} titleColor={titleColor} />

      <IonContent className={eventView?.event?.active ? "main-content active" : "main-content"} scrollEvents onIonScroll={changeHeightHandler}>
        <IonCard className="slideshow-card">
          <IonCardContent>
            {eventView?.images !== undefined ? <Slideshow images={eventView?.images} /> : null}
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol>
                <IonText className="title">{eventView.event?.title}</IonText>
              </IonCol>
            </IonRow>
            <HR />
            <IonRow>
              <IonCol>
                <div className="ion-text-justify">{eventView.event?.summary}</div>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol>
                <IonText className="price-title">استان/شهر</IonText>
              </IonCol>
              <IonCol>
                <IonText className="price-value">{eventView.event?.state} / {eventView.event?.city}</IonText>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol size="3">
                <IonText className="price-title">مبلغ</IonText>
              </IonCol>
              <IonCol size="9">
                <IonText className="price-value">{eventView.event?.price}</IonText>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol size="3">
                <IonText className="price-title">مدت</IonText>
              </IonCol>
              <IonCol size="9">
                <IonText className="price-value">{eventView.event?.period}</IonText>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="3">
                <IonText className="price-title">زمان حرکت</IonText>
              </IonCol>
              <IonCol size="9">
                <IonText className="price-value dir-ltr">{eventView.event?.departure_date}</IonText>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="3">
                <IonText className="price-title">زمان بازگشت</IonText>
              </IonCol>
              <IonCol size="9">
                <IonText className="price-value dir-ltr">{eventView.event?.return_date}</IonText>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="3">
                <IonText className="price-title">محل حرکت</IonText>
              </IonCol>
              <IonCol size="9">
                <IonText className="price-value">{eventView.event?.move_location}</IonText>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonCard>

        {eventView.event?.appliances!=null ?
        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol size="12">
                <IonText className="price-title">لوازم ضروری</IonText>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonList>
                <IonText className="price-value">
                {applicances}
                </IonText>
              </IonList>
            </IonRow>
          </IonCardContent>
        </IonCard> : null}

        {eventView.event?.appliances_optional!=null ?
        <IonCard>
          <IonCardContent>
            <IonRow>
              <IonCol size="12">
                <IonText className="price-title">لوازم اختیاری</IonText>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonList>
                <IonText className="price-value">
                {applicancesOptional}
                </IonText>
              </IonList>
            </IonRow>
          </IonCardContent>
        </IonCard>
         : null}

        <IonRow className="selector-container">
          <IonCol size="6">
            <Link to={{ pathname: `${match.params.event_id}/desc`, state: eventView.event?.description }}>
              <IonButton className="selector-button"> توضیحات </IonButton>
            </Link>
          </IonCol>
          <IonCol size="6">
          <Link to={{ pathname: `${match.params.event_id}/detail/updates`, state: eventView?.updates }}>
              <IonButton className="selector-button"> گزارش سفر </IonButton>
            </Link>
          </IonCol>
        </IonRow>
      </IonContent>

      {eventView.event?.active! ?
      <AuthContext.Consumer>
          {
            (context) => {
              return <>
                <IonCard className="add-cart-button">
                  <IonCardContent>
                    {
                      <IonButton onClick={() => registerEventHandler(context.auth)} expand='block'>
                        <IonText>{eventView.user?.registered ? 'رزرو شده' : 'رزرو موقت'}</IonText>
                      <IonIcon slot="start" icon={createOutline} /></IonButton>
                    }
                  </IonCardContent>
                </IonCard> 
                </>
            }
          }
      </AuthContext.Consumer>
      : null}

      <Modal open={mapShow} onClose={hideMapHandler} center showCloseIcon={false} classNames={{ modalContainer: "single-map-modal" }}>
        <iframe src={baseUrl + `/tour-map/${eventView.event?.id}`} />
      </Modal>
    </IonPage>
  </LoadingContainer>
}

export default EventPage